var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[(!_vm.repair)?_c('span',{staticClass:"resize-loading"},[_c('span',{staticClass:"loader"})]):_vm._e(),(_vm.repair)?_c('repair-form',{attrs:{"formErrors":_vm.formErrors,"repairData":_vm.repair,"loading":_vm.loading},on:{"formChanged":() => {
        _vm.alertLeave = true;
        _vm.get();
      },"onViewRepair":_vm.onViewRepair,"onCancelRepair":_vm.onCancelRepair,"onCloseRepairModal":_vm.onCloseRepairModal}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }